/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, "count, plural, one {": NonNullable<unknown>, s: NonNullable<unknown> }} Knp_Lookup_Deleted_Terms_ToastInputs */

const en_knp_lookup_deleted_terms_toast = /** @type {(inputs: Knp_Lookup_Deleted_Terms_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deleted ${i?.count} term${i?.["count, plural, one {"]} other ${i?.s}} successfully`)
};

const fr_knp_lookup_deleted_terms_toast = /** @type {(inputs: Knp_Lookup_Deleted_Terms_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Supprime ${i?.count} terme${i?.["count, plural, one {"]} other ${i?.s}} avec succes`)
};

const de_knp_lookup_deleted_terms_toast = /** @type {(inputs: Knp_Lookup_Deleted_Terms_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Term${i?.["count, plural, one {"]} other ${i?.s}} erfolgreich gelöscht`)
};

const it_knp_lookup_deleted_terms_toast = /** @type {(inputs: Knp_Lookup_Deleted_Terms_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eliminato correttamente il termine ${i?.count}${i?.["count, plural, one {"]} other ${i?.s}}`)
};

const ru_knp_lookup_deleted_terms_toast = /** @type {(inputs: Knp_Lookup_Deleted_Terms_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Термин ${i?.count} успешно удален.`)
};

const es_knp_lookup_deleted_terms_toast = /** @type {(inputs: Knp_Lookup_Deleted_Terms_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se eliminó correctamente el término ${i?.count} ${i?.["count, plural, one {"]} other ${i?.s}}`)
};

const zh_cn2_knp_lookup_deleted_terms_toast = /** @type {(inputs: Knp_Lookup_Deleted_Terms_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已成功删除 ${i?.count} 术语 ${i?.["count, plural, one {"]} other ${i?.s}}`)
};

const ja_knp_lookup_deleted_terms_toast = /** @type {(inputs: Knp_Lookup_Deleted_Terms_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 用語 ${i?.["count, plural, one {"]} other ${i?.s}} を正常に削除しました`)
};

const hi_knp_lookup_deleted_terms_toast = /** @type {(inputs: Knp_Lookup_Deleted_Terms_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} पद${i?.["count, plural, one {"]} other ${i?.s}} सफलतापूर्वक हटा दिया गया`)
};

const pt_pt2_knp_lookup_deleted_terms_toast = /** @type {(inputs: Knp_Lookup_Deleted_Terms_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Termo __PH_0_ ...`)
};

/**
* | output |
* | --- |
* | "Deleted {count} term{count, plural, one {} other {s}} successfully" |
*
* @param {Knp_Lookup_Deleted_Terms_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_deleted_terms_toast = /** @type {((inputs: Knp_Lookup_Deleted_Terms_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Deleted_Terms_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_deleted_terms_toast(inputs)
	if (locale === "de") return de_knp_lookup_deleted_terms_toast(inputs)
	if (locale === "it") return it_knp_lookup_deleted_terms_toast(inputs)
	if (locale === "ru") return ru_knp_lookup_deleted_terms_toast(inputs)
	if (locale === "es") return es_knp_lookup_deleted_terms_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_deleted_terms_toast(inputs)
	if (locale === "ja") return ja_knp_lookup_deleted_terms_toast(inputs)
	if (locale === "hi") return hi_knp_lookup_deleted_terms_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_deleted_terms_toast(inputs)
	return en_knp_lookup_deleted_terms_toast(inputs)
});